import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import slugify from 'slugify'
import { useSelector } from '~/store/hooks'

import DirectLink from '~/components/features/header/directLink'
import ButtonLink from '~/components/features/header/buttonLink'

import transformLink from '~/utils/transformLink'

const NavLevel = ({
  level,
  activeSubnav,
  activeSubSubnav,
  activeSubSubSubnav,
  changeLevel,
}) => {
  let navigation = null
  const lang = useSelector((state) => state.lang)

  const datas = useStaticQuery(graphql`
    query {
      navigations: allContentfulNavigationLevel(
        filter: {
          firstLevel: { eq: true }
          profile: { eq: false }
          distributionChannel: { title: { eq: "Site internet" } }
        }
      ) {
        nodes {
          links {
            label
            customLink
            subnav {
              links {
                label
                customLink
                pageLink {
                  ... on Node {
                    ... on ContentfulSearch {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulDatasOdre {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulEvent {
                      title
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulNews {
                      title
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulProject {
                      title
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulLabo {
                      title
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulHomepage {
                      title
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulContact {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulSimulator {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulGovernance {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulProfile {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulAction {
                      title
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulHub {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulPage {
                      title
                      slug
                      customType
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulMap {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                    ... on ContentfulNewsroomList {
                      title
                      slug
                      node_locale
                      internal {
                        type
                      }
                    }
                  }
                }
                subnav {
                  links {
                    label
                    customLink
                    pageLink {
                      ... on Node {
                        ... on ContentfulSearch {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulDatasOdre {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulEvent {
                          title
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulNews {
                          title
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulProject {
                          title
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulLabo {
                          title
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulHomepage {
                          title
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulContact {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulSimulator {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulGovernance {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulProfile {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulAction {
                          title
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulHub {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulPage {
                          title
                          slug
                          customType
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulMap {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                        ... on ContentfulNewsroomList {
                          title
                          slug
                          node_locale
                          internal {
                            type
                          }
                        }
                      }
                    }
                    subnav {
                      links {
                        label
                        customLink
                        pageLink {
                          ... on Node {
                            ... on ContentfulSearch {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulDatasOdre {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulEvent {
                              title
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulNews {
                              title
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulProject {
                              title
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulLabo {
                              title
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulHomepage {
                              title
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulContact {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulSimulator {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulGovernance {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulProfile {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulAction {
                              title
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulHub {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulPage {
                              title
                              slug
                              customType
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulMap {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                            ... on ContentfulNewsroomList {
                              title
                              slug
                              node_locale
                              internal {
                                type
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            pageLink {
              ... on Node {
                ... on ContentfulSearch {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulDatasOdre {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulEvent {
                  title
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulNews {
                  title
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulProject {
                  title
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulLabo {
                  title
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulHomepage {
                  title
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulContact {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulSimulator {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulGovernance {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulProfile {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulAction {
                  title
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulHub {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulPage {
                  title
                  slug
                  customType
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulMap {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
                ... on ContentfulNewsroomList {
                  title
                  slug
                  node_locale
                  internal {
                    type
                  }
                }
              }
            }
          }
          node_locale
        }
      }
    }
  `)

  datas.navigations.nodes.forEach((item) => {
    if (item.node_locale === lang) {
      navigation = item
    }
  })

  return (
    <ul className="main-nav">
      {navigation?.links?.map((item, i) => {
        const slugItem = slugify(item.label).toLowerCase()
        const { url, contentTypeContentful } = transformLink(item, true, false)

        return (
          <li
            className={`main-nav__item main-nav__item--level-1 ${level > 1 ? 'is-hidden' : ''}`}
            key={i}
          >
            {item.subnav !== null ? (
              <>
                <button
                  className="main-nav-link-wrap"
                  onClick={() => changeLevel(2, slugItem, null, null)}
                  aria-label={item.label}
                >
                  <ButtonLink navType="mainNav" text={item.label} />
                </button>
                <div
                  className={`main-nav__subnav ${activeSubnav === slugItem ? 'is-active' : ''}`}
                >
                  <div
                    className={`main-nav__item main-nav__item--level-more ${activeSubnav === slugItem ? 'is-visible' : ''} ${activeSubnav === slugItem && (level === 3 || level === 4) ? 'is-hidden' : ''}`}
                  >
                    <DirectLink
                      text={item.label}
                      link={url}
                      contentType={contentTypeContentful}
                      navType="mainNav"
                    />
                  </div>
                  <ul className="main-nav__subnav-list">
                    {item.subnav.links.map((item, i) => {
                      const slugSubItem = slugify(item.label).toLowerCase()
                      const { url, contentTypeContentful } = transformLink(
                        item,
                        true,
                        false,
                      )

                      return (
                        <li
                          className={`main-nav__item main-nav__item--level-more ${activeSubnav === slugItem ? 'is-visible' : ''} ${activeSubnav === slugItem && (level === 3 || level === 4) ? 'is-hidden' : ''}`}
                          key={i}
                        >
                          {item.subnav !== null ? (
                            <>
                              <button
                                className="main-nav-link-wrap"
                                onClick={() =>
                                  changeLevel(3, slugItem, slugSubItem, null)
                                }
                                aria-label={item.label}
                              >
                                <ButtonLink
                                  text={item.label}
                                  navType="mainNav"
                                />
                              </button>
                              <div
                                className={`main-nav__subnav ${activeSubSubnav === slugSubItem ? 'is-active' : ''}`}
                              >
                                <div
                                  className={`main-nav__item main-nav__item--level-more ${activeSubSubnav === slugSubItem ? 'is-visible' : ''} ${activeSubSubnav === slugSubItem && level === 4 ? 'is-hidden' : ''}`}
                                >
                                  <DirectLink
                                    text={item.label}
                                    link={url}
                                    contentType={contentTypeContentful}
                                    navType="mainNav"
                                  />
                                </div>

                                <ul className="main-nav__subnav-list">
                                  {item.subnav.links.map((item, i) => {
                                    const slugSubSubItem = item.label
                                      ? slugify(item.label).toLowerCase()
                                      : ''
                                    const { url, contentTypeContentful } =
                                      transformLink(item, true, false)

                                    return (
                                      <li
                                        className={`main-nav__item main-nav__item--level-more ${activeSubSubnav === slugSubItem ? 'is-visible' : ''} ${activeSubSubnav === slugSubItem && level === 4 ? 'is-hidden' : ''}`}
                                        key={i}
                                      >
                                        {item.subnav !== null ? (
                                          <>
                                            <button
                                              className="main-nav-link-wrap"
                                              onClick={() =>
                                                changeLevel(
                                                  4,
                                                  slugItem,
                                                  slugSubItem,
                                                  slugSubSubItem,
                                                )
                                              }
                                              aria-label={item.label}
                                            >
                                              <ButtonLink
                                                text={item.label}
                                                navType="mainNav"
                                              />
                                            </button>
                                            <div
                                              className={`main-nav__subnav ${activeSubSubSubnav === slugSubSubItem ? 'is-active' : ''}`}
                                            >
                                              <div
                                                className={`main-nav__item main-nav__item--level-more ${activeSubSubSubnav === slugSubSubItem ? 'is-visible' : ''}`}
                                              >
                                                <DirectLink
                                                  text={item.label}
                                                  link={url}
                                                  contentType={
                                                    contentTypeContentful
                                                  }
                                                  navType="mainNav"
                                                />
                                              </div>

                                              <ul className="main-nav__subnav-list">
                                                {item.subnav.links.map(
                                                  (item, i) => {
                                                    const {
                                                      url,
                                                      contentTypeContentful,
                                                    } = transformLink(
                                                      item,
                                                      true,
                                                      false,
                                                    )

                                                    return (
                                                      <li
                                                        className={`main-nav__item main-nav__item--level-more ${activeSubSubSubnav === slugSubSubItem ? 'is-visible' : ''}`}
                                                        key={i}
                                                      >
                                                        <DirectLink
                                                          text={item.label}
                                                          link={url}
                                                          contentType={
                                                            contentTypeContentful
                                                          }
                                                          navType="mainNav"
                                                        />
                                                      </li>
                                                    )
                                                  },
                                                )}
                                              </ul>
                                            </div>
                                          </>
                                        ) : (
                                          <DirectLink
                                            text={item.label}
                                            link={url}
                                            contentType={contentTypeContentful}
                                            navType="mainNav"
                                          />
                                        )}
                                      </li>
                                    )
                                  })}
                                </ul>
                              </div>
                            </>
                          ) : (
                            <DirectLink
                              text={item.label}
                              link={url}
                              contentType={contentTypeContentful}
                              navType="mainNav"
                            />
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </>
            ) : (
              <DirectLink
                text={item.label}
                link={url}
                contentType={contentTypeContentful}
                navType="mainNav"
              />
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default NavLevel
